import { render, staticRenderFns } from "./PromoSubvendorSelect.vue?vue&type=template&id=17b8f176&"
import script from "./PromoSubvendorSelect.vue?vue&type=script&lang=js&"
export * from "./PromoSubvendorSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VChip } from 'vuetify/lib/components/VChip';
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAutocomplete,VChip,VContainer})


/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1783431190/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('17b8f176')) {
      api.createRecord('17b8f176', component.options)
    } else {
      api.reload('17b8f176', component.options)
    }
    module.hot.accept("./PromoSubvendorSelect.vue?vue&type=template&id=17b8f176&", function () {
      api.rerender('17b8f176', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PromoSubvendorSelect.vue"
export default component.exports